/**
 * Current published versions of legal documents.
 *
 * Bump these when the corresponding /legal page is materially updated.
 * Sign-up records the active versions into `tos_acceptances` so we have
 * an audit trail of exactly which document the user agreed to.
 *
 * Version format: ISO date (YYYY-MM-DD) of the last material change.
 */
export const LEGAL_VERSIONS = {
  terms: "2026-08-18",
  privacy: "2026-06-21",
  contractorAgreement: "2026-08-18",
  cookies: "2026-06-21",
  acceptableUse: "2026-08-18",
} as const;
